import { useState } from "react";
import { toast } from "@/components/ui/notify";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useRegisterLoss } from "@/features/lines/hooks";
import { getFriendlyErrorMessage } from "@/lib/api-client";

interface LossFormProps {
  lineId: string;
  onDone: () => void;
}

type LossType = "REJECT" | "WASTE" | "REWORK";

export function LossForm({ lineId, onDone }: LossFormProps) {
  const [lossQty, setLossQty] = useState("");
  const [lossType, setLossType] = useState<LossType>("REJECT");
  const [lossReason, setLossReason] = useState("");
  const registerLoss = useRegisterLoss(lineId);

  async function submit() {
    const n = Number(lossQty);
    if (!Number.isFinite(n) || n <= 0) {
      toast.error("Informe quantidade de perda válida (> 0).");
      return;
    }
    try {
      await registerLoss.mutateAsync({
        lossType,
        quantity: n,
        reason: lossReason.trim() || undefined,
      });
      toast.success("Perda registrada.");
      onDone();
    } catch (err) {
      toast.error("Falha ao registrar perda.", {
        description: getFriendlyErrorMessage(err),
      });
    }
  }

  return (
    <div className="space-y-2 rounded border bg-background p-2">
      <Label htmlFor="op-loss-qty" className="text-xs">
        Quantidade perdida
      </Label>
      <Input
        id="op-loss-qty"
        type="number"
        min="0"
        step="1"
        placeholder="0"
        value={lossQty}
        onChange={(e) => setLossQty(e.target.value)}
      />
      <Label htmlFor="op-loss-type" className="text-xs">
        Tipo
      </Label>
      <select
        id="op-loss-type"
        value={lossType}
        onChange={(e) => setLossType(e.target.value as LossType)}
        className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm"
      >
        <option value="REJECT">Refugo</option>
        <option value="WASTE">Desperdício</option>
        <option value="REWORK">Retrabalho</option>
      </select>
      <Label htmlFor="op-loss-reason" className="text-xs">
        Motivo (opcional)
      </Label>
      <Input
        id="op-loss-reason"
        value={lossReason}
        onChange={(e) => setLossReason(e.target.value)}
        maxLength={500}
      />
      <div className="flex gap-1.5">
        <Button
          size="sm"
          className="flex-1"
          onClick={() => void submit()}
          disabled={registerLoss.isPending}
        >
          {registerLoss.isPending ? "Registrando…" : "Registrar"}
        </Button>
        <Button size="sm" variant="ghost" onClick={onDone}>
          Cancelar
        </Button>
      </div>
    </div>
  );
}
